export const RVGRID_COLUMN_SIZE_OPTIONS = {
    ID: "id",
    UUID: "uuid",
    XXSMALL: "xxsmall",
    XSMALL: "xsmall",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    XLARGE: "xlarge",
    XXLARGE: "xxlarge",
} as const;

export type RVGridColumnSize = (typeof RVGRID_COLUMN_SIZE_OPTIONS)[keyof typeof RVGRID_COLUMN_SIZE_OPTIONS];

// Include all grid-related query parameters that should be removed when changing tabs
export const GRID_FILTER_PARAMS = ["orderBy", "filterBy", "page"] as const;
